/*
 * Filename: cq-template-list.tsx
 */

import React from 'react';
import CQLightningStudioHeader from './../cq-header/cq-header';
import CQTemplateHeader from './cq-template-header';
import CQTemplate from './cq-template';
import { LSTemplatesStore } from './../../store/ls-template-store';
import { CQAppStore } from '../../store/cq-app-store';
import TemplateListController from './template-list.controller';
import DeployedTemplateListModal from './deployed-templates';
import { CQAppConstant } from '../../app-constants';
import { CQStoreManager } from '../../store/store-manager';
import './cq-templates.css';
import { CQMasterDataStore } from '../../store/cq-master-data.store';

class CQLightningStudioTemplateListContainer extends React.Component<{ history: any },
    {
        templates: { [Field: string]: string }[],
        deployedTemplatesModalVisibility: boolean,
        deployedTemplates: [],
        selectedTemplate: {}
    }>{
    private readonly templateListCtrl: TemplateListController;
    private readonly storeManager: CQStoreManager;
    constructor(props: Readonly<{ history: any }>) {
        super(props);
        this.templateListCtrl = new TemplateListController();
        this.storeManager = new CQStoreManager();
        this.state = {
            templates: [],
            deployedTemplatesModalVisibility: false,
            deployedTemplates: [],
            selectedTemplate: {}
        };
    }

    async componentDidMount() {
        try{
            CQAppStore.loader.setVisibility(true);
            CQMasterDataStore.OutputConfig.reset();
            CQMasterDataStore.RuleElements.reset();
            CQMasterDataStore.GridObject.reset();
            await this.templateListCtrl.getBaseClasses();
            this.setState(await this.templateListCtrl.getTemplateListState(this.state));
            CQAppStore.loader.setVisibility(false);
        }
        catch(error){
            CQAppStore.loader.setVisibility(false);
        }
    }


    render() {
        return (
            <>
                <CQLightningStudioHeader />
                {/* container of app */}
                <div className="slds-grid slds-grid_vertical full-height">
                    {/* header to be included here */}
                    <main className="full-height slds-p-around_small scroll-content">
                        {/* page wrapper */}
                        <div className="full-height slds-grid slds-grid_vertical">
                            {/* page header */}
                            <CQTemplateHeader fetchDeployedTemplates={this.fetchDeployedTemplates} />
                            {/* page header */}
                            <div className="bg-white full-height templates-wrapper slds-p-around_medium slds-grid slds-grid_vertical slds-grid_align-spread">
                                <div className="slds-grid slds-gutters slds-wrap slds-grid_vertical-stretch">
                                    {/* template div */}
                                    {
                                        this.state.templates.length > 0 &&
                                        this.state.templates.map((templateItem: { [Field: string]: string }) => {
                                            return (
                                                <CQTemplate key={templateItem.label} templateItem={templateItem}
                                                    setSelectedTemplate={LSTemplatesStore.setSelectedTemplate}>
                                                </CQTemplate>
                                            );
                                        }
                                        )
                                    }
                                    {/* template div */}
                                </div>
                                {/* Deployed template modal */}
                                {
                                    this.state.deployedTemplates.length > 0 && this.state.deployedTemplatesModalVisibility &&
                                    <DeployedTemplateListModal closeDeployedTemplateModal={this.closeDeployedTemplateModal}
                                        templateList={this.state.deployedTemplates} onDeployedTemplateSelection={this.onDeployedTemplateSelection} />
                                }
                                {/* Deployed template modal */}
                            </div>
                        </div>
                        {/* page wrapper */}
                    </main>
                </div>
            </>
        );
    }

    public fetchDeployedTemplates = async () => {
        if(this.state.deployedTemplates.length === 0) {
            CQAppStore.loader.setVisibility(true);
            this.setState(await this.templateListCtrl.getDeployedTemplateListState(this.state));
            CQAppStore.loader.setVisibility(false);

            if(this.state.deployedTemplates.length === 0){
                const infoObj = {
                    informationalMessage: CQAppConstant.INFORMATIONAL_MESSAGES.LOAD_MESSAGE,
                    componentName: ''
                }
                CQAppStore.informational.dispatchError(infoObj);
            }
        }else{
            this.setState({ deployedTemplatesModalVisibility: true });
        }
    }

    public closeDeployedTemplateModal = () => {
        this.setState({ deployedTemplatesModalVisibility: false });
    }

    public onDeployedTemplateSelection = (selectedTemplate: any) => {
        let selectedTemplateObject: any = this.state.templates.filter((template) => {
            if(
                (selectedTemplate.hasOwnProperty("templateType") && selectedTemplate.templateType === template.templateType)||
                (!selectedTemplate.hasOwnProperty("templateType") && selectedTemplate.template.includes(template.templateType))
            ){
                selectedTemplate.template = template.name === 'cqGridGenerator100' ? 'cqGridGenerator920' : template.name;
                return template;
            }
        });
        LSTemplatesStore.setSelectedTemplate(selectedTemplateObject[0]);
        this.storeManager.storeDeployedTemplate(selectedTemplate);
        this.props.history.push(CQAppConstant.NAVIGATION.TEMPLATES_CONFIGURATION, { deployementStatus: true });
        this.closeDeployedTemplateModal();
    }

}
export default CQLightningStudioTemplateListContainer;
